// หน้าตาร่วมของ popup ใบเสนอราคา (หลังสร้างใบเสนอราคา / ตัวอย่างรูป / เปิด PDF) — SweetAlert2 + HTML
// ใส่ CSS ครั้งเดียวตอนใช้ครั้งแรก, ไอคอนเป็น SVG path ของ MUI

export const escapeHtml = (s) =>
  String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

const ICON_PATHS = {
  pdf: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z',
  image: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z',
  copy: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z',
  share: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z',
  download: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z',
  check: 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
  chevron: 'M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z',
};

export const icon = (name, size = 20) =>
  `<svg viewBox="0 0 24 24" width="${size}" height="${size}" aria-hidden="true" style="fill:currentColor;flex-shrink:0"><path d="${ICON_PATHS[name]}"/></svg>`;

const CSS = `
.qt-pop { border-radius: 16px !important; padding-bottom: 1.25em !important; }
.qt-pop .swal2-title { font-size: 1.3rem; padding-top: .6em; }
.qt-pop .swal2-html-container { margin: .75em 1.25em 0; padding: 2px; overflow-x: hidden; }
.qt-pop .swal2-actions { margin-top: 1.1em; }
.qt-pop .swal2-styled { border-radius: 10px !important; padding: .6em 1.6em; font-weight: 600; }
.qt-pop .swal2-styled:focus { box-shadow: 0 0 0 3px rgba(25,118,210,.22) !important; }
.qt-pop .swal2-close { border-radius: 10px; margin: 6px 6px 0 0; color: #9e9e9e; }
.qt-pop .swal2-close:hover { background: #f5f5f5; color: #424242; }
.qt-pop .swal2-close:focus { box-shadow: none; }
.qt-pop .swal2-close:focus-visible { box-shadow: 0 0 0 3px rgba(25,118,210,.22); }
.qt-sub { font-size: 13px; color: #757575; margin-top: -2px; word-break: break-word; }

.qt-doc { display: inline-flex; align-items: center; gap: 6px; padding: 8px 6px 8px 16px;
  border-radius: 12px; background: #e3f2fd; border: 1px solid #bbdefb; }
.qt-doc-lbl { font-size: 11.5px; color: #5c7a99; text-align: left; line-height: 1.2; }
.qt-doc-no { font-size: 20px; font-weight: 700; color: #1565c0; letter-spacing: .5px; line-height: 1.3; }
.qt-iconbtn { border: 0; background: transparent; color: #1565c0; width: 36px; height: 36px; border-radius: 8px;
  display: inline-flex; align-items: center; justify-content: center; cursor: pointer; }
.qt-iconbtn:hover { background: rgba(21,101,192,.1); }

.qt-label { font-size: 13px; color: #757575; margin: 20px 2px 8px; text-align: left; font-weight: 600; }
/* การ์ดเรียงตามพื้นที่ใน popup เอง (ไม่พึ่งความกว้างจอ) — แคบกว่า ~2×210px ก็เรียงลงมาแถวละใบ */
.qt-opts { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 210px), 1fr)); gap: 10px; }
.qt-opt { --c: #1976d2; --bg: #e3f2fd; display: flex; align-items: center; gap: 12px; width: 100%; min-width: 0; box-sizing: border-box;
  padding: 14px 12px 14px 14px; border: 1.5px solid #e0e0e0; border-radius: 14px; background: #fff;
  cursor: pointer; text-align: left; font-family: inherit; transition: border-color .15s, box-shadow .15s, background .15s; }
.qt-opt:hover, .qt-opt:focus-visible { border-color: var(--c); box-shadow: 0 3px 10px rgba(0,0,0,.08); outline: none; }
.qt-opt:active { background: var(--bg); }
.qt-opt-ic { width: 46px; height: 46px; border-radius: 12px; display: flex; align-items: center; justify-content: center;
  background: var(--bg); color: var(--c); flex-shrink: 0; }
.qt-opt-body { flex: 1; min-width: 0; }
.qt-opt-t { font-weight: 700; font-size: 15.5px; color: #212121; }
.qt-opt-s { font-size: 12.5px; color: #757575; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.qt-opt-go { color: #bdbdbd; display: flex; }
.qt-opt-go:empty { display: none; }
.qt-opt.is-done { border-color: var(--c); background: var(--bg); }
.qt-opt.is-done .qt-opt-go { color: var(--c); }
.qt-opt.pdf { --c: #c62828; --bg: #ffebee; }
.qt-opt.img { --c: #2e7d32; --bg: #e8f5e9; }

.qt-preview { max-height: 56vh; overflow: auto; background: #eef1f5; padding: 14px; border-radius: 12px;
  border: 1px solid #e3e7ec; }
.qt-preview img { display: block; width: 100%; border-radius: 4px; background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,.14); }
.qt-page { font-size: 12px; color: #8a96a3; text-align: center; margin: 6px 0 14px; }
.qt-page:last-child { margin-bottom: 0; }

.qt-actions { display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; margin-top: 16px; }
.qt-btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 11px 20px;
  border-radius: 10px; font: 600 15px/1.2 inherit; font-family: inherit; cursor: pointer; border: 1.5px solid transparent;
  transition: filter .15s, background .15s; }
.qt-btn:hover { filter: brightness(.95); }
.qt-btn.primary { background: #2e7d32; color: #fff; }
.qt-btn.outline { background: #fff; color: #1976d2; border-color: #1976d2; }
.qt-btn.outline:hover { background: #e3f2fd; filter: none; }
@media (max-width: 460px) { .qt-btn { flex: 1 1 100%; } }

.qt-msg { min-height: 22px; margin-top: 12px; font-size: 14px; }
.qt-msg span { display: inline-flex; align-items: center; gap: 6px; padding: 5px 12px; border-radius: 12px; text-align: left; }
.qt-msg.ok span { color: #1b5e20; background: #e8f5e9; }
.qt-msg.err span { color: #b71c1c; background: #ffebee; }
.qt-msg.info span { color: #455a64; background: #eceff1; }
`;

let cssInjected = false;
export const ensureQtPopupCss = () => {
  if (cssInjected || typeof document === 'undefined') return;
  const style = document.createElement('style');
  style.setAttribute('data-qt-popup', '');
  style.textContent = CSS;
  document.head.appendChild(style);
  cssInjected = true;
};

// การ์ดตัวเลือก (เช่น ไฟล์ PDF / รูปภาพ) — kind: 'pdf' | 'img'
export const optionCard = (id, kind, iconName, title, subtitle) => `
  <button type="button" id="${id}" class="qt-opt ${kind}">
    <span class="qt-opt-ic">${icon(iconName, 26)}</span>
    <span class="qt-opt-body">
      <div class="qt-opt-t">${escapeHtml(title)}</div>
      <div class="qt-opt-s">${escapeHtml(subtitle)}</div>
    </span>
    <span class="qt-opt-go"></span>
  </button>`;

export const actionButton = (id, variant, iconName, label) =>
  `<button type="button" id="${id}" class="qt-btn ${variant}">${icon(iconName, 20)}${escapeHtml(label)}</button>`;

// ข้อความสถานะใต้ปุ่ม — tone: 'ok' | 'err' | 'info'
export const setQtMsg = (el, text, tone = 'ok') => {
  if (!el) return;
  el.className = `qt-msg ${tone}`;
  el.innerHTML = text ? `<span>${tone === 'ok' ? icon('check', 16) : ''}${escapeHtml(text)}</span>` : '';
};
